export const GET_TRANSACTION_HISTORY_START =
  'GET_TRANSACTION_HISTORY_START';
export const GET_TRANSACTION_HISTORY_SUCCESS =
  'GET_TRANSACTION_HISTORY_SUCCESS';
export const GET_TRANSACTION_HISTORY_ERROR =
  'GET_TRANSACTION_HISTORY_ERROR';
